<template>
  <div class="mobile-cohort-table">
    <div
      ref="container"
      class="mobile-cohort-table__container"
      @scroll="handleScroll"
    >
      <div
        v-for="(chunk, chunkIndex) in visibleChunks"
        :key="chunkIndex"
        class="mobile-cohort-table__chunk"
      >
        <CohortItem
          v-for="(item, index) in chunk"
          :key="item.id"
          :item="item"
          :index="index + chunkIndex * chunkSize"
          @update-active-date="updateActiveDate"
          @size-change="updateSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CohortItem from './CohortItem.vue';

export default {
  components: {
    CohortItem,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      activeDates: [],
      chunkSize: 20,
      visibleChunkCount: 3,
      scrollThreshold: 200,
    };
  },
  computed: {
    dataSources() {
      return this.data.map((cohort, index) => ({
        id: `cohort-${index}`,
        cohortName: cohort.cohortName,
        dates: cohort.dates,
        activeDate: this.activeDates[index] || [],
      }));
    },
    chunks() {
      const chunks = [];
      for (let i = 0; i < this.dataSources.length; i += this.chunkSize) {
        chunks.push(this.dataSources.slice(i, i + this.chunkSize));
      }
      return chunks;
    },
    visibleChunks() {
      return this.chunks.slice(0, this.visibleChunkCount);
    },
  },
  methods: {
    updateActiveDate({ index, activeDate }) {
      this.$set(this.activeDates, index, [...activeDate]);
    },
    updateSize(index) {
      this.$set(this.activeDates, index, [...(this.activeDates[index] || [])]);
    },
    handleScroll() {
      const container = this.$refs.container;
      if (!container) return;
      const nearBottom =
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - this.scrollThreshold;
      if (nearBottom && this.visibleChunkCount < this.chunks.length) {
        this.visibleChunkCount += 1;
      }
    },
  },
  watch: {
    data: {
      handler() {
        this.activeDates = Array(this.data.length).fill().map(() => []);
        this.visibleChunkCount = 3;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.mobile-cohort-table {
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;

  &__container {
    height: 100%;
    overflow-y: auto;
  }

  &__separator {
    height: 4px;
    width: 100%;
    background-color: #e7ecf1;
    position: absolute;
    left: 0;
    right: 0;
  }

  @media (max-width: 650px) {
    display: block;
  }

  &__cohort {
    position: relative;
  }

  &__cohort-header {
    font-size: 14px;
    font-weight: 600;
    color: #000;
    padding: 16px 16px 8px;
    background-color: #f7f7f7;
  }

  &__dates {
    border: none;
    &.el-collapse {
      border-top: none;
    }
  }

  &__date-chunk_last {
    .mobile-cohort-table__date {
      &:last-child {
        .el-collapse-item__header {
          border-bottom-width: 0;
        }
      }
    }

  }

  .el-collapse-item {
    margin-bottom: 0;
  }

  &__date {
    .el-collapse-item__header {
      border-bottom-width: 3px;
    }

    padding: 0 16px;

    .el-collapse-item__content {
      padding: 0!important;
    }

    .el-icon-arrow-right {
      font-family: "Font Awesome 6 Pro" !important;
      color: #7d7d7d;

      &.is-active {
        transform: rotate(180deg);
      }

      &:before {
        content: "\f107";
        font-size: 16px!important;
      }
    }

    &-header {
      font-size: 13px;
      font-weight: 600;
      color: #000;
    }
  }

  &__metrics {
    padding: 4px 0;
  }

  &__metric {
    display: flex;
    justify-content: space-between;
    padding: 8px 0;
    border-top: 1px solid #e7ecf1;

    &-name {
      color: #6c716f;
      &.bold {
        font-weight: 600;
      }
    }

    &-value {
      font-size: 13px;
      color: #3c3c3c;

      &.bold {
        font-weight: 600;
      }
    }
  }
}
</style>
